export const GOOGLE_MAPS_API_KEY = "AIzaSyANJHBiVzjGgMj5b37sdRePGWg4DR7f8QI";
export const DEFAULT_LATITUDE = -0.3260188821663661; // -6.2004218;
export const DEFAULT_LONGITUDE = 118.0119915875; // 106.7362876;
export const DEFAULT_ZOOM = 5;
